package com.essntl.features.tag.ui.addedittag

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditTagValidation {
    val addEditTagForm = AddEditTagForm()
}

class AddEditTagForm : Form() {
    val name =
        StringField(NonEmptyValidator)


    override val fields: List<Field> =
        listOf(name)
}